if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) {
        console.warn('Product form missing <form> element', this);
        this.classList.remove('is-initializing');
        return;
      }
      this.idInput = this.form.querySelector('[name=id]');

      if (this.idInput) {
        this.idInput.disabled = false;
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.buttonsWrapper = this.querySelector('.product-form__buttons');
      this.loadingWrapper = this.querySelector('.product-form__loading');

      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.submitButton) {
        console.warn('Product form missing submit button', this);
      }

      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.classList.remove('is-initializing');
        this.classList.add('is-ready');
        if (this.loadingWrapper) {
          this.loadingWrapper.classList.remove('loading');
          if (this.submitButton) {
            this.submitButton.classList.remove('addToCart--not-loaded');
          }
        }
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      this.submitButton.classList.add('clicked');

      const activeForm = evt.target;
      const formData = new FormData(activeForm);
      const activeIdInput = activeForm.querySelector('[name=id]') || this.idInput;
      const fallbackVariantId = activeIdInput ? activeIdInput.value : null;
      const variantId = formData.get('id') || fallbackVariantId;

      if (!variantId) {
        console.error('Add to cart blocked: missing variant id', this);
        this.handleErrorMessage(window.variantStrings?.unavailable || '{{ "products.product.unavailable" | t }}');
        this.submitButton.classList.remove('loading');
        this.submitButton.classList.remove('clicked');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        this.error = true;
        return;
      }

      formData.set('id', variantId);
      const sectionsToRender = this.cartNotification ? this.cartNotification.getSectionsToRender() : [];
      const sectionIds = sectionsToRender.map((section) => section.id);

      if (sectionIds.length) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      } else {
        formData.delete('sections');
        formData.delete('sections_url');
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        // .then((response) => this.ensureSectionsOnResponse(response, sectionIds, formData.get('sections_url')))
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            if (this.cartNotification) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cartNotification.renderContents(response) });
              }, { once: true });
            }
            quickAddModal.hide(true);
          } else if (this.cartNotification) {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          var submitButtonTemp = this.submitButton;
          setTimeout(function() {
            submitButtonTemp.classList.remove('clicked');
          }, 1500);
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    ensureSectionsOnResponse(response, sectionIds, sectionsUrl) {
      if (response.sections) return Promise.resolve(response);

      return this.fetchFallbackSections(sectionIds, sectionsUrl || window.location.pathname)
        .then((sections) => {
          response.sections = sections;
          return response;
        })
        .catch((error) => {
          console.error('Fallback fetch for sections failed', error);
          return response;
        });
    }

    fetchFallbackSections(sectionIds, sectionsUrl) {
      const url = new URL(sectionsUrl, window.location.origin);
      url.searchParams.set('sections', sectionIds.join(','));

      return fetch(url.href, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then((res) => res.json());
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}